module.exports = __webpack_public_path__ + "static/media/caramida-aparenta-klinker-Argentis.db37c855.jpg";